import _ from 'lodash';

export default function hasPluginOfType(editor, type) {
  return !!editor && _.some(editor.plugins, p => p.type === type);
}
